import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lohi-bol-ocr-audit-container',
  templateUrl: './bol-ocr-audit-container.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BolOcrAuditContainerComponent {
  constructor() {}
}
